import { Component, Input } from '@angular/core';
import { StoreAttributeSummaryStats } from '../../../models/store-attribute.model';

@Component({
  selector: 'app-store-attribute-summary-cards',
  templateUrl: './summary-cards.component.html',
  styleUrls: ['./summary-cards.component.scss'],
})
export class StoreAttributeSummaryCardsComponent {
  @Input() stats!: StoreAttributeSummaryStats;
}
